"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CircleAlert as AlertCircle, ArrowUpRight, CircleQuestionMark as HelpCircle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Condition() {
  const shouldReduceMotion = useReducedMotion();
  const paragraphs = [{
    id: "p1",
    text: "Some replacement components may be available new, while others may appear as used or removed-from-service parts. The condition should always be stated clearly on the individual product page."
  }, {
    id: "p2",
    text: "When considering a used component, pay closer attention to its visible condition, known history and compatibility. For electrical or control components, available model and connection information can be especially important."
  }, {
    id: "p3",
    text: "Do not describe a used component as refurbished, rebuilt or tested unless there is genuine information supporting that claim."
  }];
  return <section id="partsconditionnotice" data-nav="light" className="w-full bg-background text-foreground border-t border-border py-16 md:py-24">
      <div className="max-w-[80rem] mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-40px"
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="max-w-3xl">
          {/* Industrial metadata header */}
          <div className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-primary border-b border-primary/30 pb-1 mb-4">
            <AlertCircle className="size-3.5" aria-hidden="true" />
            <span>Equipment Policy // Parts Catalog</span>
          </div>

          {/* Section Headline */}
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl uppercase tracking-tight font-bold text-foreground mb-8">
            New and Used Mechanical Bull Parts
          </h2>

          {/* Editorial Text Block */}
          <div className="space-y-6 font-sans text-base sm:text-lg leading-relaxed text-foreground/90 border-l-2 border-border pl-5 md:pl-7">
            {paragraphs.map((item, i) => <p key={item.id} data-index={i} className={i === 2 ? "font-medium text-foreground" : "text-muted-foreground"}>
                {item.text}
              </p>)}
          </div>

          {/* Direct verification action */}
          <div className="mt-10 pt-6 border-t border-border/60 flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-xs font-mono text-muted-foreground uppercase tracking-wider">
              <HelpCircle className="size-3.5 shrink-0" aria-hidden="true" />
              <span>Need pinout verification or component specs?</span>
            </div>
            <Button asChild variant="outline" size="sm" className="font-mono text-xs uppercase tracking-wider">
              <Link to="/ContactPage">
                Ask a Technician
                <ArrowUpRight className="size-3.5 ml-1.5" aria-hidden="true" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}